module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAAEtQTFRFWbnm9fv90uz4Vrjm8/r9Pa3iLqfgW7rn2u/52e/58fn9VLfm7vj8O6zijtDud8brs+D0PK3ifsns2O75RLDjZb7o4fL6+/3+////bexGxwAAAFVJREFUKM/N0TkOgDAMRFGz7wQSSLj/SSnzLTl9XM4rZiTLVzipA85YAP9EG/ZNCTrWjsLyXiBqVTNl0XPb0ZswD2+yYLlzTgjMAeFgDnAqB1ypng/+pj80mJjtmysAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/image/moreIcon.png
// module id = em8v
// module chunks = 1